import { useMemo } from 'react';
import { useIsReferralDisabledForState } from '~/hooks';
import { useIsParentOfficeSelector } from '~/hooks/useIsParentOfficeSelector';
import { useIsReferralRebuildEnabled } from '~/hooks/useIsReferralRebuildEnabled';

/**
 * Whether the legacy office referral programme (`/dashboard/referral`) is shown.
 *
 * GOTU-7435: the rebuild (GOTU-6523) has no office surface, so with the flag on
 * an office sees no referral programme at all. Mobile keeps this as a separate
 * `useIsLegacyOfficeReferralVisible` because its pro-side consumers lead to the
 * new screen; the portal has no pro side, so the flag folds in here.
 *
 * The business rules underneath (parent office, state blocklist) still apply
 * with the flag off.
 */
export const useIsReferralProgramVisible = () => {
  const isParentOffice = useIsParentOfficeSelector();
  const isReferralScreenDisabledState = useIsReferralDisabledForState();
  const isReferralRebuildEnabled = useIsReferralRebuildEnabled();

  const shouldShowReferralProgram = useMemo(() => {
    if (isReferralScreenDisabledState || isParentOffice || isReferralRebuildEnabled) {
      return false;
    }

    return true;
  }, [isParentOffice, isReferralScreenDisabledState, isReferralRebuildEnabled]);

  return shouldShowReferralProgram;
};
